import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AboutProvince.css';
import ignatius from '../../ignatius.jpeg';

const AboutProvince = () => {
  const institutions = [
    { year: '1844', name: "St. Joseph’s School & College", city: "Tiruchy" },
    { year: '1850', name: "St. Mary’s School", city: "Dindigul" },
    { year: '1855', name: "St. Mary’s School", city: "Madurai" },
    { year: '1923', name: "St. Xavier’s College", city: "Palayamkottai" },
    { year: '1925', name: "Loyola College", city: "Chennai" },
    { year: '1950', name: "St. Xavier’s B.Ed College", city: "Palayamkottai" },
  ];

  return (
    <section className="about-province-section py-5">
      <div className="container">
        {/* Header Section */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <span className="badge rounded-pill bg-primary-soft text-primary px-3 py-2 mb-3 text-uppercase fw-bold ls-2">
              Our Heritage
            </span>
            <h2 className="display-4 fw-bold text-navy mb-4">Madurai Province</h2>
            <div className="title-divider mx-auto"></div>
          </div>
        </div>

        <div className="row g-5 align-items-center">
          {/* Visual/Image Side */}
          <div className="col-lg-5 order-2 order-lg-1">
            <div className="image-stack">
              <div className="image-card main-img shadow-lg">
                <img 
                  src={ignatius} 
                  alt="St Ignatius" 
                  className="img-fluid rounded-4"
                />
              </div>
              <div className="stats-card bg-white p-4 shadow rounded-4 border-start border-primary border-5">
                <h4 className="fw-bold mb-0 text-primary">Est. 1606</h4>
                <p className="small text-muted mb-0">Foundations laid by Robert de Nobili</p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="col-lg-7 order-1 order-lg-2">
            <div className="content-box ps-lg-4">
              <h3 className="h4 fw-bold text-primary mb-3">A Legacy of Missions</h3>
              <p className="lead-text mb-4">
                The <span className="highlight">Madurai Province</span> bridges two eras of Jesuit history: 
                the <span className="text-navy fw-semibold">Old Madura Mission</span> (1606–1773) and the 
                <span className="text-navy fw-semibold"> New Madura Mission</span> (1937–1952).
              </p>
              
              <div className="history-milestones">
                <div className="milestone-item d-flex mb-3">
                  <div className="ms-icon">1929</div>
                  <div className="ms-text">Raised to <span className="fw-bold">Vice-Province</span> under Toulouse.</div>
                </div>
                <div className="milestone-item d-flex mb-4">
                  <div className="ms-icon">1952</div>
                  <div className="ms-text">Became an <span className="fw-bold text-success">Independent Province</span>.</div>
                </div>
              </div>

              <p className="description text-muted mb-5">
                While Robert de Nobili planted the seeds, it was the French Jesuits who built the 
                pillars of excellence we see today, moving the headquarters from Madurai to Tiruchirapalli 
                to consolidate growth.
              </p>
            </div>
          </div>
        </div>

        {/* Institutions Grid */}
        <div className="mt-5 pt-5">
          <h4 className="text-center fw-bold mb-4">Pillars of Education</h4>
          <div className="row row-cols-1 row-cols-md-3 g-3">
            {institutions.map((inst, index) => (
              <div className="col" key={index}>
                <div className="inst-card p-3 h-100 border-0 shadow-sm rounded-3 bg-white">
                  <div className="d-flex align-items-center">
                    <span className="year-badge me-3">{inst.year}</span>
                    <div>
                      <h6 className="mb-0 fw-bold">{inst.name}</h6>
                      <small className="text-muted">{inst.city}</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutProvince;